/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLeaf2 = createReactComponent("outline", "leaf-2", "IconLeaf2", [["path", { "d": "M5 21c.5 -4.5 2.5 -8 7 -10", "key": "svg-0" }], ["path", { "d": "M7.5 15q -3.5 0 -4.5 -6a8.4 8.4 0 0 1 3.438 .402a12 12 0 0 1 -.052 -.793c0 -3.606 3.204 -5.609 3.204 -5.609s2.003 1.252 2.842 3.557q 2.568 -1.557 6.568 -1.557q .396 3.775 -1.557 6.568c2.305 .839 3.557 2.842 3.557 2.842s-3 2.59 -7 2.59c0 1 0 1 .5 3q -6 0 -7 -5", "key": "svg-1" }]]);

export { IconLeaf2 as default };
//# sourceMappingURL=IconLeaf2.mjs.map
